export default __webpack_public_path__ + "static/media/person01-1.5x.a606b7b7.png";